import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=4ba7343c&"
import script from "./Badge.vue?vue&type=script&lang=ts&"
export * from "./Badge.vue?vue&type=script&lang=ts&"
import style0 from "./Badge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports